import { Theme } from '@mui/material/styles';
import { CSSProperties } from 'react';

export const countdownTimerStyles = (theme: Theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    mx: 1,
    [theme.breakpoints.down('md')]: { mx: 1 },
    [theme.breakpoints.down('sm')]: { mx: 0.5 }
  },
  number: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '80px',
    fontVariationSettings: "'wght' 300",
    mb: 1,
    [theme.breakpoints.down('xl')]: { fontSize: '44px' },
    [theme.breakpoints.down('lg')]: { fontSize: '32px' },
    [theme.breakpoints.down('md')]: { fontSize: '24px' },
    [theme.breakpoints.down('sm')]: { fontSize: '20px', mb: 0.5 }
  },
  itemsContainer: {
    display: 'inline-block',
    margin: '0 20px',
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: { margin: '0 15px' },
    [theme.breakpoints.down('md')]: { margin: '0 12px' },
    [theme.breakpoints.down('sm')]: { margin: '0 8px' }
  },
  containerSubtitle: {
    display: 'flex',
    justifyContent: 'center',
    width: 'auto'
  },
  allContainer: {
    display: 'inline-block'
  },
  title: {
    textAlign: 'center',
    fontVariationSettings: "'wght' 300",
    pb: 3.5,
    [theme.breakpoints.up('xl')]: { pb: 4.5, fontSize: '40px' },
    [theme.breakpoints.down('md')]: { pb: 2 },
    [theme.breakpoints.down('sm')]: { pb: 2 }
  },
  gif: {
    height: 'auto',
    width: 'auto'
  },
  allItems: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      pb: 2
    }
  },
  boldText: {
    fontVariationSettings: "'wght' 600"
  },
  subtitle: {
    fontSize: '12px',
    color: theme.palette.secondary.main,
    [theme.breakpoints.up('xl')]: { fontSize: '22px' },
    [theme.breakpoints.up('md')]: { fontSize: '14px' },
    [theme.breakpoints.up('sm')]: { fontSize: '14px' }
  }
});
